module.exports = __webpack_public_path__ + "7f4ccc64cce76dc14dd66633fdcce783.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-21.png
// module id = 2194
// module chunks = 0